import { render, staticRenderFns } from "./SourceFileCard.vue?vue&type=template&id=74cac72f&scoped=true&"
import script from "./SourceFileCard.vue?vue&type=script&lang=js&"
export * from "./SourceFileCard.vue?vue&type=script&lang=js&"
import style0 from "./SourceFileCard.vue?vue&type=style&index=0&id=74cac72f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cac72f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VRow})
